// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectOutsideDoorQueryResult, selectOutsideDoorsPageLoading, selectOutsideDoorsShowInitWaitingMessage} from '../_selectors/outside-door.selectors';

export class OutsideDoorsDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectOutsideDoorsPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectOutsideDoorsShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectOutsideDoorQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
